import React from 'react';
import classNames from 'classnames';
import list from '../sandbox-6/list';



class List extends React.Component {

    constructor(props) {

        var {log = console.log, sortBy = undefined, selection = {}, selectionStyle, filter = '', sortOrder = undefined, onSelectionChange = () => {}, rows, columns, ...otherProps} = props;

        super(props);

        this.log = log;
        this.debug = log;

        this.otherProps = otherProps;

        this.state = {};
        this.state.sortOrder = sortOrder;
        this.state.filter = filter;
        this.state.sortBy = sortBy;
        this.state.rows = rows;

        this.state.rowOrder = this.state.rows.map((row, index) => {
            return index;
        });

        this.props.columns.forEach((column, index) => {
            if (column.text == undefined && typeof column.value == 'function')
                column.text = column.value;
        });

        this.state.rowFilter = this.computeRowFilter(this.state.filter);
        this.state.rowOrder = this.computeRowOrder(this.state.sortBy, this.state.sortOrder);
        this.state.rowSelection = selection;

        


    }

    componentDidMount() {
    }

    computeRowOrder(sortBy, sortOrder) {

        let column = this.props.columns[sortBy];
        let rows = this.state.rows;

        if (column == undefined || column.value == undefined) {
            this.log('Not able to sort.');
            return null;
        }


        this.log('sorting by column', column);
        this.log('Sort Order', sortBy, sortOrder);

        let rowOrder = this.state.rowOrder.sort((a, b) => {
            let rowA = rows[a];
            let rowB = rows[b];
            let valueA = column.value(rowA);
            let valueB = column.value(rowB);

            let compare = valueA > valueB;

            return sortOrder == 'ascending' ? compare : !compare;


        });

        return rowOrder;
    }


    computeRowFilter(filter) {

        let rows = this.state.rows;

        if (typeof filter != 'string')
            return null;

        filter = filter.toUpperCase();

        let filterRow = (row) => {

            if (filter == '')
                return row;

            for (let column of this.props.columns) {
                if (column.text) {
                    let value = column.text(row);
                    if (value) {
                        let text = value.toString();

                        if (text.toUpperCase().includes(filter)) {
                            return row;

                        }
                    }
                }
            }

        };

        let rowFilter = {};

        rows.forEach((row, index) => {
            if (filterRow(row))
                rowFilter[index] = row;

        })

        return rowFilter;

    }



    onRowClick(index) {
        let row = this.state.rows[index];
        let rowSelection = this.state.rowSelection;

        switch(this.props.selectionStyle) {
            case 'multiple': {
                if (rowSelection[index])
                    delete rowSelection[index];
                else
                    rowSelection[index] = row;
                break;
            }
            case 'single': {
                rowSelection = {};
                rowSelection[index] = row;
                break;
            }

        }

        if (typeof this.props.onSelectionChange == 'function') {
            let selectedRows = [];
            
            for (let key in rowSelection) {
                selectedRows.push(this.state.rows[key]);
            }

            this.props.onSelectionChange(selectedRows);
        }

        this.setState({rowSelection:rowSelection});
    };



    onColumnClick(index) {

        if (this.props.columns[index] != undefined) {
            let column = this.props.columns[index];

            if (column.value) {

                let rows = this.state.rows;
                let sortOrder = this.state.sortOrder;
                let sortBy = this.state.sortBy;
                let rowOrder = this.state.rowOrder;

                if (sortOrder == 'descending' || sortBy != index) {
                    rowOrder = rowOrder.sort((a, b) => {
                        let rowA = rows[a];
                        let rowB = rows[b];
                        return column.value(rowA) > column.value(rowB);
                    });

                    sortOrder = 'ascending';
                }
                else {
                    rowOrder = rowOrder.sort((a, b) => {
                        let rowA = rows[a];
                        let rowB = rows[b];
                        return column.value(rowA) < column.value(rowB);
                    });

                    sortOrder = 'descending';
                }

                console.log(rowOrder);
                this.setState({rowOrder:rowOrder, sortBy:index, sortOrder:sortOrder});
            }
        }            
    }

/*
    setFilter(filter) {
        this.setState({filter:filter, rowFilter:this.computeRowFilter(filter)});
    }


    setRows(rows) {
        this.setState({rows:rows, filter:this.state.filter, rowFilter:this.computeRowFilter(this.state.filter)});
    }

    setSelection(selection) {
        this.setState({selection:selection});
    }
*/
    select() {
//        this.state.rowSelection = {};
//        this.forceUpdate();
        this.setState({rowSelection:{}});
        this.props.onSelectionChange([]);

    }

    render() {

        return (
            <div {...this.otherProps}> 
                <List.Table>
                    <List.Header>
                        <List.Columns 
                            onColumnClick={this.onColumnClick.bind(this)} 
                            columns={this.props.columns} 
                            sortOrder={this.state.sortOrder} 
                            sortBy={this.state.sortBy}>
                        </List.Columns>
                    </List.Header>
                    <List.Body >
                        <List.Rows
                            onRowClick={this.onRowClick.bind(this)} 
                            filter={this.state.rowFilter} 
                            selection={this.state.rowSelection} 
                            order={this.state.rowOrder} 
                            rows={this.state.rows} 
                            columns={this.props.columns}>
                        </List.Rows>
                    </List.Body>

                </List.Table>
            </div>
        );
    }


}


List.Header = function(props) {

    var {style = {}, ...props} = props;
    
    style.position = 'sticky';
    style.top = 0;    

    return (
        <thead style={style} {...props}/>
    );

}

List.Cell = function(props) {

    var {rowIndex, columnIndex, content = undefined, row, column, ...props} = props;

    props.key = columnIndex;
    props.index = columnIndex;

    if (content == undefined)
        content = column.content;

    if (content == undefined)
        content = column.text; 

    if (content == undefined)
        content = column.value; 

    if (typeof(content) == 'function') 
        content = content(row, rowIndex, columnIndex)

    switch(column.align) {
        case 'left':
            props.className = classNames(props.className, 'text-start');
            break;
        case 'right':
            props.className = classNames(props.className, 'text-end');
            break;
        case 'center':
            props.className = classNames(props.className, 'text-center');
            break;
    }

    return (
        <td {...props}>
            {content}
        </td>
    );
}




List.Column = function(props) {

    var {column, rows, columnIndex, onColumnClick = () => {}, sortBy, sortOrder, ...props} = props;

    props.key = columnIndex;
    props.index = columnIndex;
    props.className = '';
    props.style = {fontSize:'90%', ...column.style};

    props.onClick = (event) => {
        onColumnClick(columnIndex);
    };

    switch(column.align) {
        case 'left':
            props.className = classNames(props.className, 'text-start');
            break;
        case 'right':
            props.className = classNames(props.className, 'text-end');
            break;
        case 'center':
            props.className = classNames(props.className, 'text-center');
            break;
    }

    // Must have a backgroiund color if fixed header
    props.style.background = 'var(--bs-light)';        

    let renderSort = () => {

        let symbol = '▲';
        let sort = sortBy == columnIndex ? sortOrder : undefined;
        
        let style = {};
        style.fontSize = '75%';

        switch(sort) {
            case 'ascending':
                break;

            case 'descending':
                symbol = '▼';
                break;

            // Use opacity 0 with same symbol to keep column widths the same
            default:
                style.opacity = 0;
                break;
        }
    
        if (symbol != undefined)
            return <span style={style} className='align-middle px-1'>{symbol}</span>

    }
    return (
        <th {...props} xstyle={{transform:'rotate(180deg)'}}>
            {column.name}
            {renderSort()}
        </th>
    );
}


List.Columns = function(props) {

    var {columns, onColumnClick, sortBy, sortOrder, ...props} = props;

    let children = columns.map((column, columnIndex) => {

        return (
            <List.Column key={columnIndex} onColumnClick={onColumnClick} column={column} sortBy={sortBy} sortOrder={sortOrder} columnIndex={columnIndex}/>
        );
    });

    return (
        <tr {...props}>
            {children}
        </tr>

    );            
}


List.Row = function(props) {

    var {columns, onRowClick = () => {}, rowIndex, row, ...props} = props;

    let children = columns.map((column, columnIndex) => {
        return <List.Cell key={columnIndex} row={row} column={column} rowIndex={rowIndex} columnIndex={columnIndex}/>
    });

    return (
        <tr {...props}>
            {children}
        </tr>
    );
}


List.Rows = function(props) {

    var {columns, onRowClick = () => {}, selection, order, filter, rows, ...props} = props;

    let html = rows.map((row, rowIndex) => {

        let onClick = (event) => {
            onRowClick(rowIndex);
        };

        // Translate the row index accordning to sorting
        if (order) {
            rowIndex = order[rowIndex];
            row = rows[rowIndex];
        }


        if (!filter || filter[rowIndex]) {
            let className = '';

            if (selection && selection[rowIndex])
                className = 'table-primary';
            
            return <List.Row columns={columns} key={rowIndex} row={row} rowIndex={rowIndex} onClick={onClick} className={className}/>

        }
    });

    return (
        <>
            {html}
        </>
    );
}

List.Body = function(props) {

    return (
        <tbody {...props}/>
    );
}


List.Table = function(props) {

    var {rows, columns, className, style = {}, ...props} = props;

    style.cursor = 'default';
    className = classNames(className, 'table table-hover');

    return (
        <table className={className} style={style} {...props}>
        </table>
    );
}


export default List;
